import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {//this component shows the delivery acknowledgement text.
    let IV1_PageDetails = useContext(RecordsManagementContext).IV1_PageDetails
    return (
        <div className="delivery_text">
            {IV1_PageDetails.DeliveryAcknowledgement ? <><b>DELIVERY ACKNOWLEDGEMENT: </b>{IV1_PageDetails.DeliveryAcknowledgement}</> : ""}
                </div>
    )
}